<div class="container-fluid mt-3">
  <h4>Nguồn Proxy</h4>

  <div class="row mb-3">
    <div class="col-md-4">
      <input class="form-control" placeholder="Tìm kiếm..." [(ngModel)]="query.queryString" (keyup.enter)="search()" />
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary" (click)="openModal()">
        <i class="fas fa-plus"></i> Thêm nguồn
      </button>
    </div>
  </div>

  <table class="table table-bordered table-sm">
    <thead class="thead-light">
      <tr>
        <th>Tên</th>
        <th>Ghi chú</th>
        <th>Ngày tạo</th>
        <th style="width:120px">Thao tác</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let s of sources">
        <td>{{ s.name }}</td>
        <td>{{ s.note }}</td>
        <td>{{ s.createdTime | date:'dd/MM/yyyy' }}</td>
        <td>
          <button class="btn btn-sm btn-outline-primary mr-1" (click)="openModal(s)">
            <i class="fas fa-edit"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger" (click)="deleteSource(s.id)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      <tr *ngIf="sources.length === 0">
        <td colspan="4" class="text-center text-muted">Không có dữ liệu</td>
      </tr>
    </tbody>
  </table>

  <app-pagination [totalItems]="total" [pageSize]="query.pageSize" [pageNumber]="query.pageNumber"
                  (onPageChanged)="onPageChange($event)"></app-pagination>
</div>

<!-- Modal -->
<ng-template #sourceModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ isNew ? 'Thêm nguồn proxy' : 'Sửa nguồn proxy' }}</h5>
    <button class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Tên</label>
      <input class="form-control" [(ngModel)]="editingSource.name" />
    </div>
    <div class="form-group">
      <label>Ghi chú</label>
      <textarea class="form-control" rows="3" [(ngModel)]="editingSource.note"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()">Hủy</button>
    <button class="btn btn-primary" (click)="save()">Lưu</button>
  </div>
</ng-template>
